import axios from 'axios'

import { Service } from './base'
import { PreLoadable } from './preloader'
import { langifyUrl } from '@shared/utils/functions'


export const UrlRetreiverServiceMixin = {
  urls: null,

  methods: {
    getUrl(name, params={}) {
      let urls = this.$options.urls

      if (urls == null) {
        throw new Error(
          'Urls option required if you willing to use `getUrl` method!'
        )
      }

      let url = urls[name] || ''

      if (!url) {
        throw new Error(`Urls have no "${name}" url!`)
      }

      for (let param in params) {
        url = url.replace(`:${param}`, params[param])
      }

      return url
    }
  }
}

export const TranslatedUrlRetreiverServiceMixin = {
  mixins: [UrlRetreiverServiceMixin],
  urls: null,

  methods: {
    getUrl(name, params={}) {
      return langifyUrl(
        UrlRetreiverServiceMixin.methods.getUrl.apply(this, arguments)
      )
    }
  }
}

export const DataReceiveService = Service.extend({
  http: axios,
  mixins: [TranslatedUrlRetreiverServiceMixin, PreLoadable],

  methods: {
    getData(url, callback, parameters={}) {
      return new Promise((resolve, reject) => {
        this.setLoading()
        this.$options.http.get(url, parameters)
          .then(response => {
            let data = response.data.data

            if (typeof callback !== 'undefined') {
              callback(data)
            }

            resolve(data)
          }, e => {
            reject(e)
          })
          .then(any => {
            this.unsetLoading()
            return any
          })
      })
    },

    sendData(url, data, callback, parameters={}, method='post') {
      return new Promise((resolve, reject) => {
        this.setLoading()
        this.$options.http[method](url, data, parameters)
          .then(response => {
            let data = response.data.data

            if (typeof callback !== 'undefined') {
              callback(data)
            }

            resolve(data)
          }, e => {
            reject(e)
          })
          .then(any => {
            this.unsetLoading()
            return any
          })
      })
    },
  }
})



// WEBPACK FOOTER //
// ./src/js/shared/services/data.js